import { render, staticRenderFns } from "./studenttics.vue?vue&type=template&id=01d85209&scoped=true"
import script from "./studenttics.vue?vue&type=script&lang=js"
export * from "./studenttics.vue?vue&type=script&lang=js"
import style0 from "./studenttics.vue?vue&type=style&index=0&id=01d85209&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d85209",
  null
  
)

export default component.exports